import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import emailjs from '@emailjs/browser';
import pageHeaderBg from "../assets/images/page-header-bg.jpg";

function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [termsError, setTermsError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreedToTerms) {
      setTermsError('Please accept the Privacy Statement and Terms & Conditions to continue.');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');
    setTermsError('');

    const form = e.target;
    const formData = new FormData(form);

    const templateParams = {
      to_email: 'hellotruckcbe@gmail.com, support@hellotruck.in',
      from_name: `${formData.get('fname')} ${formData.get('lname')}`,
      from_email: formData.get('email'),
      phone: formData.get('phone'),
      message: formData.get('message') || '(No message provided)',
    };

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
        process.env.REACT_APP_EMAILJS_BOOKING_TEMPLATE_ID || 'YOUR_TEMPLATE_ID',
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY'
      );

      setSubmitMessage('Message sent successfully! We will get back to you soon.');
      form.reset();
      setAgreedToTerms(false);
    } catch (error) {
      console.error('Email send failed:', error);
      setSubmitMessage('Failed to send message. Please try again or call us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const formSection = document.querySelector(
        ".page-contact-us .row.align-items-center",
      );
      if (formSection) {
        formSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="contact-page">
      <div
        className="page-header parallaxie"
        style={{ backgroundImage: `url(${pageHeaderBg})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Contact us
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      contact us
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-contact-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="contact-us-form">
                <div className="section-title">
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Send message <span>with us</span>
                  </h2>
                </div>

                <div className="contact-form">
                  <form
                    id="contactForm"
                    onSubmit={handleSubmit}
                    className="wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="row">
                      <div className="form-group col-md-6 mb-4">
                        <input
                          type="text"
                          name="fname"
                          className="form-control"
                          id="fname"
                          placeholder="First Name"
                          required
                        />
                        <i className="fa-regular fa-user"></i>
                        <div className="help-block with-errors"></div>
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input
                          type="text"
                          name="lname"
                          className="form-control"
                          id="lname"
                          placeholder="Last Name"
                          required
                        />
                        <i className="fa-regular fa-user"></i>
                        <div className="help-block with-errors"></div>
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          id="email"
                          placeholder="Email Address"
                          required
                        />
                        <i className="fa-regular fa-envelope"></i>
                        <div className="help-block with-errors"></div>
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input
                          type="text"
                          name="phone"
                          className="form-control"
                          id="phone"
                          placeholder="Phone Number"
                          required
                        />
                        <img
                          src="/hellotruck-web-images/icon-phone-primary.svg"
                          alt=""
                        />
                        <div className="help-block with-errors"></div>
                      </div>

                      <div className="form-group col-md-12 mb-5">
                        <textarea
                          name="message"
                          className="form-control"
                          id="message"
                          rows="4"
                          placeholder="Message"
                        ></textarea>
                        <div className="help-block with-errors"></div>
                      </div>

                      <div className="col-lg-12 mb-3">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="termsCheckboxContact"
                            checked={agreedToTerms}
                            onChange={(e) => {
                              setAgreedToTerms(e.target.checked);
                              if (e.target.checked) setTermsError('');
                            }}
                          />
                          <label className="form-check-label" htmlFor="termsCheckboxContact">
                            I agree to the <Link to="/privacy" target="_blank">Privacy Statement</Link> and <Link to="/terms" target="_blank">Terms & Conditions</Link>
                          </label>
                        </div>
                        {termsError && (
                          <div className="text-danger mt-2" style={{ fontSize: '14px' }}>
                            {termsError}
                          </div>
                        )}
                      </div>

                      <div className="col-lg-12">
                        <div className="contact-form-btn">
                          <button type="submit" className="btn-default" disabled={isSubmitting}>
                            {isSubmitting ? 'Sending...' : 'submit message'}
                          </button>
                          {submitMessage && (
                            <div className={`mt-3 ${submitMessage.includes('successfully') ? 'text-success' : 'text-danger'}`}>
                              {submitMessage}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="contact-us-content">
                <div className="section-title section-title-center">
                  <h3 className="wow fadeInUp">contact form</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Get in to <span>touch</span>
                  </h2>
                </div>

                <div className="contact-info-list">
                  <div className="contact-info-item wow fadeInUp" data-wow-delay="0.2s">
                    <div className="icon-box">
                      <img src="/hellotruck-web-images/icon-phone.svg" alt="" />
                    </div>
                    <div className="contact-info-content">
                      <p>call to question</p>
                      <h3>
                        <a href="tel:+917053315331">+91 70 5331 5331</a>
                      </h3>
                    </div>
                  </div>

                  <div className="contact-info-item wow fadeInUp" data-wow-delay="0.4s">
                    <div className="icon-box">
                      <img src="/hellotruck-web-images/icon-mail.svg" alt="" />
                    </div>
                    <div className="contact-info-content">
                      <p>send e-mail</p>
                      <h3>
                        <a href="mailto:support@hellotruck.in">
                          support@hellotruck.in
                        </a>
                      </h3>
                    </div>
                  </div>

                  <div className="contact-info-item wow fadeInUp" data-wow-delay="0.6s">
                    <div className="icon-box">
                      <img src="/hellotruck-web-images/icon-location.svg" alt="" />
                    </div>
                    <div className="contact-info-content">
                      <p>visit anytime</p>
                      <h3>
                        No. 7, Kasthuribai Gandhi Nagar 3rd St,
                        Varadharajapuram, Singanallur, Coimbatore - 641015
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="google-map">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="google-map-iframe">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.3071105618146!2d77.0230996!3d11.015568900000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba8592033cac837%3A0x1b671a19a6c46d21!2sHello%20Truck!5e0!3m2!1sen!2sin!4v1744297245315!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="HelloTruck Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
